import loadScript from '../util/loadscript';
import loadCSS from '../util/loadcss';
import getSuffix from '../util/get-suffix';
import { fetchModuleList } from '../util/fetch-meta';
import templateTransform from '../util/template-transform';
import lodashGet from 'lodash.get';
const Cache = {};
let CacheModueList = {};
async function getSelfModule(moduleName, version) {
  await loadScript(`https://g.alicdn.com/aliyun/util/${version}/module/${moduleName}.js`);
}

/**
 * 输入模块名称，输出模块实例
 * @param {string} moduleName 模块名称
 * @param {string} moduleListName 模块配置源
 * @param {function} fn 自定义模块获取函数
 */
export default async function getModule(moduleName, moduleListName = 'aliyun-config.ace-services-module-list', fn) {
  if (Cache[moduleName]) {
    return Cache[moduleName];
  }
  const list = CacheModueList[moduleListName];
  const moduleList = list ? list : await fetchModuleList(moduleListName);
  if (!list) {
    CacheModueList[moduleListName] = moduleList;
  }
  const target = moduleList.find(item => item.moduleName == moduleName);
  if (!target) {
    return null;
  }
  let mod = null;
  if (target.assets) {
    // 第三方服务接入
    // 解析assets
    const assetsRequestChain = target.assets.map(asset => {
      const suffix = getSuffix(asset);
      const url = templateTransform(asset, target);
      if (suffix == 'js') {
        return loadScript(url);
      } else if (suffix == 'css') {
        return loadCSS(url);
      }
    });
    await Promise.all(assetsRequestChain);
    mod = lodashGet(window, target.globalName);
    Cache[moduleName] = mod;
  } else {
    // 内置服务
    if (fn) {
      await fn(moduleName);
    } else {
      await getSelfModule(moduleName, target.version);
    }
    mod = window[`$ACE_SERVICES_${moduleName}`];
    Cache[moduleName] = mod;
  }
  return mod;
}



// WEBPACK FOOTER //
// ./src/components/get.js